// tslint:disable
/**
 * Arbeidslivsportalen-login
 * Login - ALP login service
 *
 * The version of the OpenAPI document: 0.1.0-draft
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { Configuration } from './configuration';
import { COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface RoleDto
 */
export interface RoleDto {
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof RoleDto
     */
    'name'?: string;
    /**
     * 
     * @type {RoletypeDto}
     * @memberof RoleDto
     */
    'type': RoletypeDto;
}


/**
 * Which kategory of access types a role is
 * @export
 * @enum {string}
 */

export const RoletypeDto = {
    Studiested: 'studiested',
    Praksissted: 'praksissted',
    Student: 'student',
    Systemadmin: 'systemadmin'
} as const;

export type RoletypeDto = typeof RoletypeDto[keyof typeof RoletypeDto];


/**
 * 
 * @export
 * @interface UserrolesDto
 */
export interface UserrolesDto {
    /**
     * 
     * @type {RoleDto}
     * @memberof UserrolesDto
     */
    'selectedRole'?: RoleDto;
    /**
     * 
     * @type {Array<RoleDto>}
     * @memberof UserrolesDto
     */
    'possibleRoles'?: Array<RoleDto>;
    /**
     * 
     * @type {boolean}
     * @memberof UserrolesDto
     */
    'authenticated'?: boolean;
}

        /**
        * LoginApi - object-oriented interface
        * @export
        * @class LoginApiInterface
        * @extends {BaseAPI}
        */
        export interface LoginApiInterface {
            /**
            * 
                * @summary Redirects the user to OIDC log in
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            loginGet(params: { 
                queryParams?: { return_url?: string, login_hint?: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Redirects the user to OIDC log out
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            logoutGet(params?: { 
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Fulfill login and redirect user to ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            oauth2callbackGet(params: { 
                queryParams?: { code: string, state: string, error?: string,  },
            options?: any
            }): Promise<void>;
            /**
            * 
                * @summary Return selected and possible user roles
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            userroleGet(params?: { 
            options?: any
            }): Promise<UserrolesDto>;
            /**
            * 
                * @summary Select which role the current user should use
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            userrolePost(params: { 
                roleDto: RoleDto,
            options?: any
            }): Promise<void>;
            }
        /**
        * LoginApi - object-oriented interface
        * @export
        * @class LoginApi
        * @extends {BaseAPI}
        */
            export class LoginApi extends BaseAPI implements LoginApiInterface {
            /**
            * 
                * @summary Redirects the user to OIDC log in
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            public async loginGet(params: { 
                queryParams?: { return_url?: string, login_hint?: string,  },
            options?: any
            }): Promise<void> {
            return await this.GET(
        "/login",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Redirects the user to OIDC log out
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            public async logoutGet(params?: { 
            options?: any
            }): Promise<void> {
            return await this.GET(
        "/logout",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Fulfill login and redirect user to ALP
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            public async oauth2callbackGet(params: { 
                queryParams?: { code: string, state: string, error?: string,  },
            options?: any
            }): Promise<void> {
            return await this.GET(
        "/oauth2callback",
        params && params.queryParams,
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Return selected and possible user roles
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            public async userroleGet(params?: { 
            options?: any
            }): Promise<UserrolesDto> {
            return await this.GET(
        "/userrole",
        {},
        undefined,
            params && params.options,
            );
            }
            /**
            * 
                * @summary Select which role the current user should use
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof LoginApi
            */
            public async userrolePost(params: { 
            roleDto: RoleDto,
            options?: any
            }): Promise<void> {
            return await this.POST(
        "/userrole",
        {},
        { body: params.roleDto, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockLoginApi(operations: {
            loginGet?: (params: { 
                    queryParams?: { return_url?: string, login_hint?: string,  },
                options?: any
                }) => Promise<void>
            logoutGet?: (params?: { 
                options?: any
                }) => Promise<void>
            oauth2callbackGet?: (params: { 
                    queryParams?: { code: string, state: string, error?: string,  },
                options?: any
                }) => Promise<void>
            userroleGet?: (params?: { 
                options?: any
                }) => Promise<UserrolesDto>
            userrolePost?: (params: { 
                roleDto: RoleDto,
                options?: any
                }) => Promise<void>
            }): LoginApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            loginGet: (operations.loginGet || reject("loginGet")),
            logoutGet: (operations.logoutGet || reject("logoutGet")),
            oauth2callbackGet: (operations.oauth2callbackGet || reject("oauth2callbackGet")),
            userroleGet: (operations.userroleGet || reject("userroleGet")),
            userrolePost: (operations.userrolePost || reject("userrolePost")),
            };
            }


        /**
        * RegistreringApi - object-oriented interface
        * @export
        * @class RegistreringApiInterface
        * @extends {BaseAPI}
        */
        export interface RegistreringApiInterface {
            /**
            * 
                * @summary Bekrefter mail for å fullføre brukerregistreringen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof RegistreringApi
            */
            registreringIdPost(params: { 
                pathParams: { id: string,  },
                body: string,
            options?: any
            }): Promise<string>;
            }
        /**
        * RegistreringApi - object-oriented interface
        * @export
        * @class RegistreringApi
        * @extends {BaseAPI}
        */
            export class RegistreringApi extends BaseAPI implements RegistreringApiInterface {
            /**
            * 
                * @summary Bekrefter mail for å fullføre brukerregistreringen
            * @param {*} [params] Request parameters, including pathParams, queryParams (including bodyParams) and http options.
            * @throws {RequiredError}
            * @memberof RegistreringApi
            */
            public async registreringIdPost(params: { 
                pathParams: { id: string,  },
            body: string,
            options?: any
            }): Promise<string> {
            return await this.POST(
        this.path("/registrering/{id}", params.pathParams),
        {},
        { body: params.body, contentType: "application/json" },
            params && params.options,
            );
            }
        }
            export function mockRegistreringApi(operations: {
            registreringIdPost?: (params: { 
                    pathParams: { id: string,  },
                body: string,
                options?: any
                }) => Promise<string>
            }): RegistreringApiInterface {
            const reject = (operation: string) => () => Promise.reject(new Error("Unexpected function call " + operation));
            return {
            registreringIdPost: (operations.registreringIdPost || reject("registreringIdPost")),
            };
            }



export class Random {
    seed: number;
    constructor(seed: number) {
        this.seed = seed % 2147483647;
        if (this.seed <= 0) this.seed += 2147483646;
    }
    next(): number {
        this.seed = this.seed * 16807 % 2147483647;
        return this.seed;
    }
    nextFloat(): number {
        return (this.next() - 1) / 2147483646;
    }
    nextInt(limit: number): number {
        return this.next() % limit;
    }
    pickOne<T>(options: Array<T>): T {
        return options[this.nextInt(options.length)];
    }
    uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
            var r = this.nextInt(16) | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
    nextBoolean() {
        return this.nextInt(2) == 0;
    }
}

type Factory<T> = {
    [P in keyof T]?: ((sampleData: TestSampleData) => T[P])|T[P];
};
type EnumFactory<T> = ((sampleData: TestSampleData) => T)|T;
export interface SampleModelFactories {
    RoleDto?: Factory<RoleDto> | ((testData: TestSampleData) => RoleDto);
    RoletypeDto?: Factory<RoletypeDto> | ((testData: TestSampleData) => RoletypeDto);
    UserrolesDto?: Factory<UserrolesDto> | ((testData: TestSampleData) => UserrolesDto);
}
export interface SamplePropertyValues {
    [key: string]: (sampleData: TestSampleData) => any;
}

export interface RandomGenerator {
    nextFloat: () => number;
    nextInt: (limit: number) => number;
    nextBoolean: () => boolean;
    pickOne: <T>(options: Array<T>) => T;
    uuidv4: ()  => string;
    randomEmail: () => string;
    randomPastDateTime: (now: Date) => Date;
    generate: (modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean) => any;
}

export interface TestData {
    seed?: number;
    sampleModelProperties?: SampleModelFactories;
    samplePropertyValues?: SamplePropertyValues;
}
export class TestSampleData implements RandomGenerator {
    random: Random;
    sampleModelProperties: any;
    samplePropertyValues: SamplePropertyValues;
    constructor(testData: TestData) {
        this.random = new Random(testData.seed || 100);
        this.sampleModelProperties = testData.sampleModelProperties || {};
        this.samplePropertyValues = testData.samplePropertyValues || {};
    }
    nextFloat() { return this.random.nextFloat(); }
    nextInt(limit: number) { return this.random.nextInt(limit); }
    nextBoolean() { return this.random.nextBoolean(); }
    pickOne<T>(options: Array<T>) { return this.random.pickOne(options); }
    uuidv4() { return this.random.uuidv4(); }
    randomEmail() {
        return this.pickOne(["james", "mary", "john", "patricia", "robert", "jennifer", "michael", "linda"]) +
            "." + this.pickOne(["smith", "williams", "johnson", "jones", "brown", "davis", "miller", "wilson"]) +
            "@" + this.pickOne(["a", "b", "c", "d", "e"]) + ".example." + this.pickOne(["net", "com", "org"]);
    }
    randomPastDateTime(now: Date) {
        return new Date((now.getTime() - this.nextInt(4*7*24*60*60*1000)));
    }
    generate(modelClass: string, modelVar: string, dataType: string, example?: string, isNullable?: boolean): any {
        if (this.sampleModelProperties[modelClass]) {
            const propertyFactory: Factory<any> = this.sampleModelProperties[modelClass][modelVar];
            if (propertyFactory && typeof propertyFactory === "function") {
                return propertyFactory(this);
            } else if (propertyFactory) {
                return propertyFactory;
            }
        }
        if (this.samplePropertyValues[modelVar]) {
            return this.samplePropertyValues[modelVar](this);
        }
        if (example && example !== "null") return example;
        if (dataType === "Array<string>") {
            return Array.from({length: this.arrayLength("Array<string>")}).map((i) => "foo " + i);
        }
        if (dataType.startsWith("Array<")) {
            return this.sample(dataType);
        }
        if (modelVar.endsWith("Id") || modelVar === "id") {
            return this.uuidv4();
        }
        if (dataType === "boolean") {
            return this.nextBoolean();
        }
        if (dataType === "number") {
            return this.nextInt(100);
        }
        const key = `sample${dataType}` as keyof TestSampleData;
        if( typeof this[key] === "function"){
            return this[key]();
        }
        return "foo";
    }
    arrayLength(modelClass: string) {
        return this.nextInt(3) + 1;
    }
    sample(modelName: string): any {
        switch(modelName) {
            case "RoleDto": return this.sampleRoleDto({});
            case "Array<RoleDto>": return this.sampleArrayRoleDto({});
            case "RoletypeDto": return this.sampleRoletypeDto();
            case "Array<RoletypeDto>": return this.sampleArrayRoletypeDto();
            case "UserrolesDto": return this.sampleUserrolesDto({});
            case "Array<UserrolesDto>": return this.sampleArrayUserrolesDto({});
            default: throw new Error("Unknown type "+ modelName);
        }
    }
    sampleRoleDto(template?: Factory<RoleDto>): RoleDto {
        if (typeof this.sampleModelProperties["RoleDto"] === "function") {
            return this.sampleModelProperties["RoleDto"](this);
        }

        return {
            id: template && template.id ? (typeof template.id === "function" ? (template.id as Function)(this) : template.id): this.generate("RoleDto", "id", "string", "b66987d9-857c-485a-9f60-84e334e43900", false),
            name: template && template.name ? (typeof template.name === "function" ? (template.name as Function)(this) : template.name): this.generate("RoleDto", "name", "string", "Institusjon X", false),
            type: template && template.type ? (typeof template.type === "function" ? (template.type as Function)(this) : template.type): this.generate("RoleDto", "type", "RoletypeDto", "null", false),
        };
    }
    sampleArrayRoleDto(template?: Factory<RoleDto>, length?: number): Array<RoleDto> {
        return Array.from({length: length || this.arrayLength("RoleDto")}).map(() => this.sampleRoleDto(template));
    }
    sampleRoletypeDto(template?: EnumFactory<RoletypeDto>): RoletypeDto {
        if (typeof this.sampleModelProperties["RoletypeDto"] === "function") {
            return this.sampleModelProperties["RoletypeDto"](this);
        }

        return template && typeof template === "function" ? template(this) : this.pickOne([
                RoletypeDto.Studiested,
                RoletypeDto.Praksissted,
                RoletypeDto.Student,
                RoletypeDto.Systemadmin
        ]);
    }
    sampleArrayRoletypeDto(template?: EnumFactory<RoletypeDto>, length?: number): Array<RoletypeDto> {
        return Array.from({length: length || this.arrayLength("RoletypeDto")}).map(() => this.sampleRoletypeDto());
    }
    sampleUserrolesDto(template?: Factory<UserrolesDto>): UserrolesDto {
        if (typeof this.sampleModelProperties["UserrolesDto"] === "function") {
            return this.sampleModelProperties["UserrolesDto"](this);
        }

        return {
            selectedRole: template && template.selectedRole ? (typeof template.selectedRole === "function" ? (template.selectedRole as Function)(this) : template.selectedRole): this.generate("UserrolesDto", "selectedRole", "RoleDto", "null", false),
            possibleRoles: template && template.possibleRoles ? (typeof template.possibleRoles === "function" ? (template.possibleRoles as Function)(this) : template.possibleRoles): this.generate("UserrolesDto", "possibleRoles", "Array<RoleDto>", "null", false),
            authenticated: template && template.authenticated ? (typeof template.authenticated === "function" ? (template.authenticated as Function)(this) : template.authenticated): this.generate("UserrolesDto", "authenticated", "boolean", "false", false),
        };
    }
    sampleArrayUserrolesDto(template?: Factory<UserrolesDto>, length?: number): Array<UserrolesDto> {
        return Array.from({length: length || this.arrayLength("UserrolesDto")}).map(() => this.sampleUserrolesDto(template));
    }
}
